import React from "react";

export default function Triangle(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="18">
			<path data-name="Polygon 1" d="m20 0 20 18H0Z" fill="#fff" />
		</svg>
	);
}
